<template>
  <ModalBase :show-modal="true" narrow auto-h @close-modal="close">
    <template v-slot:titlebar>
      <TitleBar variant-class="title-modal">
        <template v-slot:pretitle>
            {{ (carDetailsDeepClone.id) ? $gettext('EDIT'): $gettext('ADD') }}
        </template>
        <template v-slot:title>
          <h3 v-translate v-html="(carDetailsDeepClone.id ? $gettext('Car') + ' ' + carDetailsDeepClone.plate_number : $gettext('New car'))"/>
        </template>
      </TitleBar>
    </template>
    <template v-slot:maincontent>
      <b-form method="post" name="carForm">
        <b-form-group label-cols-sm="4" label-align-sm="right" content-cols-md="8" label-class="gk-label-margin"
                      :label="$gettext('Type of car*')">
          <b-form-radio-group 
          id="carOwnership" 
          :options="carTypeOptions" 
          v-model="carDetailsDeepClone.company_profile" 
          button-variant="outline-primary" 
          buttons></b-form-radio-group>
        </b-form-group>

        <b-form-group label-cols-sm="4" label-align-sm="right" content-cols-md="8" label-class="gk-label-margin"
                      :label="$gettext('Licence plate*')">
          <b-form-input :placeholder="'31-XPF-B'" v-model="carDetailsDeepClone.plate_number" :state="plateNumberState"></b-form-input>
        </b-form-group>

        <b-form-group label-cols-sm="4" label-align-sm="right" content-cols-md="8" label-class="gk-label-margin"
                      :label="$gettext('Brand')">
          <b-form-input :placeholder="'Ford'" v-model="carDetailsDeepClone.brand"></b-form-input>
        </b-form-group>

        <b-form-group label-cols-sm="4" label-align-sm="right" content-cols-md="8" label-class="gk-label-margin"
                      :label="$gettext('Model')">
          <b-form-input :placeholder="'Ka'" v-model="carDetailsDeepClone.model"></b-form-input>
        </b-form-group>

        <b-form-group label-cols-sm="4" label-align-sm="right" content-cols-md="8" label-class="gk-label-margin"
                      :label="$gettext('Type')">
          <b-form-input :placeholder="'Coupé'" v-model="carDetailsDeepClone.type"></b-form-input>
        </b-form-group>

        <b-form-group label-cols-sm="4" label-align-sm="right" content-cols-md="8" label-class="gk-label-margin"
                      :label="$gettext('Odometer')">
          <b-input-group>
            <template #append>
              <b-input-group-text><span>km</span></b-input-group-text>
            </template>
            <b-form-input type="number" min="0" :placeholder="'12345'" v-model="carDetailsDeepClone.odometer"></b-form-input>
          </b-input-group>
        </b-form-group>

        <b-form-group label-cols-sm="4" label-align-sm="right" content-cols-md="8" label-class="gk-label-margin"
                      :label="$gettext('Used From')">
          <b-form-datepicker :placeholder="$gettext('Choose a date')" v-model="carDetailsDeepClone.used_from"></b-form-datepicker>
        </b-form-group>

        <b-form-group label-cols-sm="4" label-align-sm="right" content-cols-md="8" label-class="gk-label-margin"
                      :label="$gettext('Used Until')">
          <b-form-datepicker :placeholder="$gettext('Choose a date')" v-model="carDetailsDeepClone.used_until"></b-form-datepicker>
        </b-form-group>
      </b-form>
    </template>
    <template v-slot:actions>
      <div style="display: flex; justify-content: space-between;">
        <GekkoButton 
          @click="closeModal"
          :text="$gettext('Cancel')"
          variant="link"
          class="text-primary px-0 mr-auto"
        />
        <div>
          <GekkoButton
            v-if="carDetailsDeepClone.id"
            @click="updateCar"
            :text="$gettext('Update')"
            class="ml-auto position-relative"
            :loading="isWaitingForResponse"
          />
          <GekkoButton
            v-else
            @click="createCar"
            :text="$gettext('Save')"
            class="ml-auto position-relative"
            :loading="isWaitingForResponse"
          />
        </div>
      </div>
    </template>
  </ModalBase>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

import CarsService from "@/store/services/cars.service";
import GekkoButton from "@/components/GekkoButton";
import ModalBase from "@/components/base_components/ModalBase";
import TitleBar from "@/components/TitleBar";

export default {
  name: "CarDetailsModal",
  components: { GekkoButton, ModalBase, TitleBar },
  props: {
    carDetails: {
      type: Object
    }
  },
  data() {
    return {
      showModal: false,
      carTypeOptions: [],
      carDetailsDeepClone: null,
      showPlateNumberWarning: false
    }
  },
  computed: {
    ...mapGetters({ 
      getCompanyId: 'main/getCompanyId',
      isWaitingForResponse: 'main/isWaitingForResponse'
    }),
    plateNumberState() {
      if (this.carDetailsDeepClone.plate_number !== null) {
        if (this.carDetailsDeepClone.plate_number.length > 1)
          return null;
      }
      if (this.showPlateNumberWarning)
        return false;
      return null;
    }
  },
  watch: {
    showModal: function (newVal) {
      if (newVal)
        this.carDetailsDeepClone = JSON.parse(JSON.stringify(this.carDetails));
    }
  },
  created () {
    this.carTypeOptions = [
      {text: "Company car", value: this.getCompanyId},
      {text: "Private car", value: null}
    ]
    this.carDetailsDeepClone = JSON.parse(JSON.stringify(this.carDetails))
  },
  methods: {
    ...mapMutations({
        setWaitingForResponse: 'main/SET_WAITING_FOR_RESPONSE'
    }),
    initModal() {
      this.showModal = true;
    },
    closeModal() {
      this.$emit('close-modal', false);
    },
    close () {
      this.$emit('close-modal', false);
    },
    createCar() {
      let vm = this;
      if (this.validateDates() && this.validatePlateNumber()) {
        this.setWaitingForResponse(true);
        var preparedData = CarsService.prepareDataForSubmit(this.carDetailsDeepClone);
        CarsService.create(preparedData)
            .then(function (response) {
              vm.$emit("carCreated", response.data);
              vm.closeModal();
            })
            .catch(function (error) {
              let msg = vm.$gettext('The car could not be added to the list.');

              if (error.status === 403) {
                msg = vm.$gettext("You do not have permissions to add a new car.");
              } else if (error.status === 400 && error.data) {
                var firstDictKey = Object.keys(error.data)[0];
                msg = error.data[firstDictKey];
              }

              vm.$store.commit('setAlert', {
                title: vm.$gettext("Error creating a new car"),
                text: msg,
                variant: "danger",
                duration: 4
              });
            }).finally(() => {
              this.setWaitingForResponse(false);
            });
      } else {
        if (!this.validatePlateNumber())
          vm.$store.commit('setAlert', {
            title: vm.$gettext("Error creating a new car"),
            text: vm.$gettext("The plate number must be filled"),
            variant: "danger",
            duration: 4
          });
        if (!this.validateDates())
          vm.$store.commit('setAlert', {
            title: vm.$gettext("Error creating a new car"),
            text: vm.$gettext("The end date must be greater or equal that the start date."),
            variant: "danger",
            duration: 4
          });
      }
    },
    updateCar() {
      let vm = this;
      if (this.validateDates() && this.validatePlateNumber()) {
        this.setWaitingForResponse(true);
        var preparedData = CarsService.prepareDataForSubmit(this.carDetailsDeepClone, this.isCompanyCar);
        CarsService.update(preparedData.id, preparedData)
          .then(function (response) {
            vm.$emit("carUpdated", response.data);
            vm.closeModal();
          }).catch(function (error) {
            if (error.status === 403) {
              vm.$store.commit('setAlert', {
                title: vm.$gettext("Error editing the car"),
                text: vm.$gettext("You do not have permissions to add a new car."),
                variant: "danger",
                duration: 4
              });
            } else if (error.status === 400) {
              var firstDictKey = Object.keys(error.data)[0];
              var msg = error.data[firstDictKey];
              vm.$store.commit('setAlert', {
                title: vm.$gettext("Error editing the car"),
                text: msg,
                variant: "danger",
                duration: 4
              });
            } else {
              vm.$store.commit('setAlert', {
                title: vm.$gettext("Error editing the car"),
                text: vm.$gettext("Something went wrong..."),
                variant: "danger",
                duration: 4
              });
            }
          }).finally(() => {
            this.setWaitingForResponse(false);
          });
        } else {
          if (!this.validatePlateNumber())
            vm.$store.commit('setAlert', {
              title: vm.$gettext("Error editing the car"),
              text: vm.$gettext("The plate number must be filled"),
              variant: "danger",
              duration: 4
            });
          if (!this.validateDates())
            vm.$store.commit('setAlert', {
              title: vm.$gettext("Error editing the car"),
              text: vm.$gettext("The end date must be greater or equal that the start date."),
              variant: "danger",
              duration: 4
            });
        }
    },
    validateDates() {
      var startDate = this.carDetailsDeepClone.used_from;
      var endDate = this.carDetailsDeepClone.used_until;
      if (startDate && endDate) {
        return endDate >= startDate;
      }
      return true;
    },
    validatePlateNumber() {
      if (this.carDetailsDeepClone.plate_number === null) {
        this.showPlateNumberWarning = true;
        return false;
      } else if (this.carDetailsDeepClone.plate_number.length === 0) {
        this.showPlateNumberWarning = true;
        return false
      }
      return true;
    }
  }
}
</script>

<style scoped>
.form-control::placeholder {
  color: 	#b3b3b3;
}
</style>